import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Config } from 'src/app/app-constant';
import { Location } from '@angular/common';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AccessMatrixDetailsPopupComponent } from '../popups/access-matrix-details-popup/access-matrix-details-popup.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
// AG Grid imports
import { ColDef, ExcelExportParams, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { firstValueFrom } from 'rxjs';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';

@Component({
  selector: 'app-grid-layout',
  templateUrl: './grid-layout.component.html',
  styleUrls: ['./grid-layout.component.scss']
})
export class GridLayoutComponent implements OnInit {
  @Input() gridData: {
    columnInfo: Array<{ label: string; propertyName: string }>;
    columnData: Array<any>;
    totalCount: number;
    totalNoOfPages: number;
    showCheckBox: boolean;
    showExportBtn: boolean;
    showGraphBtn: boolean;
    showSearchBar: boolean;
    showAddBtn: boolean;
    showDeleteBtn: boolean;
    tabsData: Array<any>;
    tabsMainData: Array<any>;
    showPermantDeleteBtn: boolean;
    showRestoreBtn: boolean;
    currentPage: number;
    showTitle: boolean;
    showBreadCrumbs: boolean;
    showAuditLog: boolean;
    showImportBtn: boolean;
    showBackBtn: boolean;
    showRefreshFunctinallity: boolean;

    countTabs: Array<any>;
  } = {
    columnInfo: [],
    columnData: [],
    totalCount: 0,
    totalNoOfPages: 0,
    showCheckBox: false,
    showExportBtn: false,
    showGraphBtn: false,
    showSearchBar: false,
    showAddBtn: true,
    showDeleteBtn: false,
    tabsData: [],
    tabsMainData: [],
    showPermantDeleteBtn: false,
    showRestoreBtn: false,
    currentPage: 0,
    showTitle: false,
    showBreadCrumbs: false,
    showAuditLog: false,
    showImportBtn: false,
    showBackBtn: false,
    showRefreshFunctinallity: false,
    countTabs: []
  };

  @Input() TableName = '';
  @Input() auditLogName = '';
  @Input() paginationUrl: string = '';
  @Input() isChangeDetected: boolean = false;
  @Input() selectedRange: any = 25;
  @Input() searchText: any = null;
  @Input() observationNumber: any = null;
  @Input() selectedStatusTabIndex: any = 0;
  @Input() selectedTypeTabIndex: any = 0;
  @Output() deleteDetailEmmiter = new EventEmitter<any>();
  @Input() showDeleteAction: boolean = false;
  @Output() editDetailEmmiter = new EventEmitter<any>();
  @Output() LoginDetailEmmiter = new EventEmitter<any>();
  @Output() searchDataEmitter = new EventEmitter<any>();
  @Output() sortAsendingEmmiter = new EventEmitter<any>();
  @Output() sortDesendingEmmiter = new EventEmitter<any>();
  @Output() graphEmmiter = new EventEmitter<any>();
  @Output() exportEmmiter = new EventEmitter<any>();
  @Output() importEmmiter = new EventEmitter<any>();
  @Output() emmitPagination = new EventEmitter<any>();
  @Output() detailsEmmiter = new EventEmitter<any>();
  @Output() detailsWithColumn = new EventEmitter<any>();
  @Output() addRecordEmmiter = new EventEmitter<any>();
  @Output() applyFilterEmmiter = new EventEmitter<any>();
  @Output() deleteMultipleRecordsEmmiter = new EventEmitter<any>();
  @Output() restoreRecordsEmmiter = new EventEmitter<any>();
  @Output() paginationDataEmmiter = new EventEmitter<any>();
  @Output() showNumberOfRecordsEmmiter = new EventEmitter<any>();
  @Output() refreshDataEmmiter = new EventEmitter<any>();
  @Output() typeTabEmmiter = new EventEmitter<any>();
  @Output() statusTabEmmiter = new EventEmitter<any>();
  @Output() importFileEmmiter = new EventEmitter<any>();
  @Output() filterEmmiter = new EventEmitter<any>();
  @Output() backbtnEmmiter = new EventEmitter<any>();
  selectedDate: any = moment();
  renderData: Array<any> = [];
  selectAllCheckbox: boolean = false;
  mulipleSelect: any = [];
  deltetedDatacount: number = 0;

  currentPage: number = 1;
  page: any = 0;
  loggedInUserRole: any;
  @ViewChild('allSelected') allSelected: any;
  sidebarModule: any = [];
  isAddFlag: boolean = true;
  isEditFlag: boolean = true;
  isPerDeleteFlag: boolean = true;
  showDelete: boolean = false;
  activeTab: any;
  private subscription!: Subscription;
  collapseSidebar: boolean = false;
  buttonColorName: any;
  subModuleButtonColor: any;
  showingCount: any = 1;
  showingOfCount: any = 0;
  previousPageTotalCount: any = 0;
  loggedInUserCompanyID: any;
  employeeIdOfMD: any = null;

  agColumnDefs: ColDef[] = [];
  agRowData: any[] = [];
  agDefaultColDef: ColDef = {
    sortable: true,
    filter: true
  };
  agFrameworkComponents: any = {}; // For custom cell renderers if any

  constructor(
    private httpService: HttpService,
    private config: Config,
    private datePipe: DatePipe,
    public fb: FormBuilder,
    public router: Router,
    private location: Location,
    private sharedService: SharedService,
    public dialog: MatDialog,
    private encryptionService: EncryptionService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.employeeIdOfMD == null) {
      this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
      if (this.router.url.includes('employeemaster')) {
        this.getCompanyDataByCompID();
      }
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.collapseSidebar = this.sharedService.getBooleanValue();

    this.selectAllCheckbox = false;
    this.mulipleSelect = [];
    this.renderColumnData();
    this.sidebarModule = JSON.parse(localStorage.getItem('pemissionModules')!);
    for (let i = 0; i < this.sidebarModule?.length; i++) {
      if (this.sidebarModule[i]?.routerName == this.router.url) {
        this.isAddFlag = this.sidebarModule[i]?.isAdd;
        this.isEditFlag = this.sidebarModule[i]?.isEdit;
        this.isPerDeleteFlag = this.sidebarModule[i]?.isPerDeleted;
      }
    }
    this.buildAgGridDefs();
  }
  ionViewWillEnter() {}
  private expandAndCollapseSidebar() {
    // this.collapseSidebar =! this.collapseSidebar;
  }
  isHideForMobileView: any;
  ngOnInit() {
    // this.loggedInUserRole = localStorage.getItem('loggedInUserRole');
    // this.loggedInUserRole = this.encyptDecryptData.decryptData(this.loggedInUserRole);

    if (this.TableName == 'Employee Master' || this.TableName == 'Companies') {
      this.isHideForMobileView = false;
    } else {
      this.isHideForMobileView = true;
    }
    window.addEventListener('resize', () => {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    });
  }
  gridApi: any;
  gridColumnApi: any;

  // --------------------------------AG GRID CODE---------------------------------------------------------

  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false // ✅ small filter box under header
  };

  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: { type: 'multiple' }, // ✅ object format for v32+
    localeText: { noRowsToShow: 'No Data Found' },
    suppressRowClickSelection: true,
    suppressRowTransform: true, // ✅ required for rowSpan to work
    getRowStyle: (params: any) => {
      if (params.node.rowPinned) {
        return {
          fontWeight: 'bold',
          background: '#f4f4f4',
          color: '#000'
        };
      }
      return null;
    },
    onFilterChanged: () => {
      // this.updatePinnedBottomRow();
    }
  };

  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    console.log('Grid ready, gridApi and gridColumnApi set.');

    // Fit columns into available screen width
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
    }, 50);

    // No header DOM icon attachment anymore
  }

  // onCellClicked(event: any) {

  //   if(event.colDef.field === 'compName' || event.colDef.field === 'linkName'  ){
  //     this.showCompanyDetails(this.selectedRow);
  //   }

  //   if(event.colDef.field === 'action'){
  //     this.editDetail(this.selectedRow);
  //   }
  // }

  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    const statusColors: Record<string, string> = {
      ACTIVE: '#4caf50', // green
      INACTIVE: '#3652f4ff', // blue-ish
      'ON-BOARDING PENDING': '#ff9800' // orange
    };

    // ✅ Strict match only
    const color = statusColors[valueUpper] || '#999';

    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
        <span style="
          border: 1px solid ${color};
          color: ${color};
          padding: 4px 10px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
          display: inline-block;
          white-space: normal;
          word-wrap: break-word;
          line-height: 1.4em;
          animation: fadeInScale 0.3s ease-in-out;
          max-width: 100%;
        ">
          ${formattedText}
        </span>
      `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }

  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    console.log('Row clicked:', event.colDef);
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
    // this.showCompanyDetails(this.selectedRow);
  }

  onRowClickedForEmployee(event: any) {
    // ⛔ Block row click if cell itself has onCellClicked
    if (event.colDef.onCellClicked) {
      event.event?.stopPropagation();
      return;
    }

    console.log('Clicked Column:**', event.colDef);
    this.selectedRow = event.data;

    if (event.colDef?.headerName === 'Company Name') {
      this.isDetailsOpen = false;
    } else if (event.colDef?.headerName === 'Company Id') {
      this.isDetailsOpen = false;
    } else if (event.colDef?.headerName === 'Action') {
      this.isDetailsOpen = false;
      this.detailsEmmiter.emit(event.data);
    } else {
      this.isDetailsOpen = true;
    }
  }

  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;

  resetGrid() {
    this.isClicked = false; // Trigger animation

    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState(); // ✅ Reset columns
    }
  }
  // --------------------------------AG GRID CODE---------------------------------------------------------

  private renderColumnData() {
    this.renderData = [];
    this.agRowData = Array.isArray(this.gridData?.columnData) ? [...this.gridData.columnData] : [];

    for (let i = 0; i < this.gridData.columnData.length; i++) {
      var output = Object.entries(this.gridData.columnData[i]).map(([key, value]) => ({ key, value }));
      this.renderData.push(output);
      this.renderData[i].checkboxCheck = false;

      if (this.router.url.includes('employeemaster')) {
        this.renderData[i].isEmployeeMD = this.gridData.columnData[i].linkName == this.employeeIdOfMD;
      } else {
        this.renderData[i].isEmployeeMD = false;
      }
    }
  }

  selectALLRecords(event: any) {
    const checked = event.checked;

    this.selectAllCheckbox = checked;
    this.showDelete = checked;
    this.mulipleSelect = [];

    for (let i = 0; i < this.renderData.length; i++) {
      this.renderData[i].checkboxCheck = checked;

      if (checked) {
        this.mulipleSelect.push(this.renderData[i]);
      }
    }
  }

  selectSingleRecord(event: any, data: any, i: number) {
    if (event.checked) {
      this.renderData[i].checkboxCheck = true;
      this.mulipleSelect.push(data);
    } else {
      this.renderData[i].checkboxCheck = false;

      // Remove this item safely
      this.mulipleSelect = this.mulipleSelect.filter((item: any) => item !== data);

      // If one item unchecked → uncheck select all
      this.selectAllCheckbox = false;
    }

    // Toggle delete button
    this.showDelete = this.mulipleSelect.length > 0;
  }

  deleteMultipleRecords() {
    this.deleteMultipleRecordsEmmiter.emit(this.mulipleSelect);
  }
  restoreData() {
    this.restoreRecordsEmmiter.emit(this.mulipleSelect);
  }
  public showSpecificButtons(data: any, compareValue: string): boolean {
    return (data.value as string).includes(compareValue);
  }
  onSearch() {
    this.searchDataEmitter.emit(this.searchText);
  }
  exportReport() {
    this.exportEmmiter.emit(this.mulipleSelect);
  }
  importReport() {
    this.importFileEmmiter.emit();
  }
  garaphReport() {
    this.graphEmmiter.emit();
  }
  addRecord() {
    this.addRecordEmmiter.emit();
  }
  editDetail(data: any) {
    this.editDetailEmmiter.emit(this.rowToKeyValueArray(data));
  }
  LoginDetail(data: any) {
    this.LoginDetailEmmiter.emit(this.rowToKeyValueArray(data));
  }
  deleteDetail(data: any) {
    this.deleteDetailEmmiter.emit(this.rowToKeyValueArray(data));
  }

  onSortAssending(data: any) {
    this.sortAsendingEmmiter.emit(data);
  }
  onSortDesending(data: any) {
    this.sortDesendingEmmiter.emit(data);
  }
  applyFilter() {
    this.applyFilterEmmiter.emit();
  }
  previousPage() {
    if (this.currentPage < 2) {
      return;
    } else {
      this.currentPage--;
      this.page--;
      this.paginationNextOrPrevious();
    }
  }
  nextPage() {
    if (this.currentPage >= this.gridData.totalNoOfPages) {
      return;
    }
    if (this.currentPage == 1) {
      this.page = 1;
    } else {
      this.page++;
    }
    this.currentPage++;
    this.paginationNextOrPrevious();
  }
  paginationNextOrPrevious() {
    localStorage.setItem('currentPageNumber', this.page);
    this.paginationDataEmmiter.emit(this.page);
  }
  showDetailsWithColumn(data: any, colName: any) {
    this.detailsWithColumn.emit({ data: this.rowToKeyValueArray(data), colName });
  }
  showDetails(data: any) {
    this.detailsEmmiter.emit(this.rowToKeyValueArray(data));
  }
  onClickConfig() {
    this.router.navigate(['/home/configrations/configuration-dashboard']);
  }
  onClickConfigName() {}
  onClickDelete() {
    this.deleteMultipleRecordsEmmiter.emit(this.mulipleSelect);
  }

  refreshData() {
    this.refreshDataEmmiter.emit();
  }
  backBtn() {
    this.backbtnEmmiter.emit();
    // this.location.back()
  }
  tabStatusChanged(event: any) {
    this.statusTabEmmiter.emit(event);
  }
  tabTypeChanged(event: any) {
    this.typeTabEmmiter.emit(event);
  }
  filterDetail(data: any) {
    this.filterEmmiter.emit(data);
  }
  showCompanyDetails(data: any) {
    this.filterEmmiter.emit(this.rowToKeyValueArray(data));
  }
  showDetailsOfAccessMatrix(data: any, popupName: any, listMainData: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = window.innerWidth <= 500 ? '100%' : window.innerWidth <= 800 ? '50%' : '50%';
    dialogConfig.data = {
      data: data,
      popupName: popupName,
      listMainData: listMainData
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    this.dialog.open(AccessMatrixDetailsPopupComponent, dialogConfig);
  }
  getCompanyDataByCompID() {
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.employeeIdOfMD = data?.data?.employeeIdOfMD;
    });
  }

  // ✅ Selection change hone par delete icon enable/disable hoga
  onSelectionChanged() {
    if (!this.gridApi) return;

    // Get selected rows and update local list
    const selectedRows = this.gridApi.getSelectedRows() || [];
    this.mulipleSelect = selectedRows;

    // Show/hide top Delete button
    this.showDelete = selectedRows.length > 0;

    // If you also want select-all checkbox to reflect grid selection:
    this.selectAllCheckbox = selectedRows.length > 0 && this.gridApi.getSelectedNodes().length === this.gridApi.getDisplayedRowCount();
  }

  onCelledClicked(event: any) {
    this.selectedRow = event.data;

    if (event.colDef?.field == undefined) {
      this.isDetailsOpen = false;
      console.log('undefined call');
    } else {
      this.isDetailsOpen = true;
    }
  }

  onPaginationChanged() {
    if (!this.gridApi) return;

    const currentPage = this.gridApi.paginationGetCurrentPage();
    const totalPages = this.gridApi.paginationGetTotalPages();

    console.log(`📄 Page changed: ${currentPage + 1}/${totalPages}`);
    this.currentPage = currentPage;

    // Call API for new page data
    // this.loadGridData(this.currentPage);
  }
  attachDeleteListener() {
    console.log('Setting up delete icon listener');
    const deleteIcon = document.getElementById('deleteIcon');

    if (deleteIcon) {
      console.log('Attaching click listener to delete icon');

      // Remove any previous listener to avoid duplicates
      deleteIcon.replaceWith(deleteIcon.cloneNode(true));
      const freshDeleteIcon = document.getElementById('deleteIcon');

      freshDeleteIcon?.addEventListener('click', () => {
        if (freshDeleteIcon.getAttribute('data-enabled') === 'true') {
          const selectedRows = this.gridApi.getSelectedRows() || [];
          this.mulipleSelect = selectedRows;
          this.deleteMultipleRecords();
        } else {
          console.log('⚠️ Delete icon clicked but disabled.');
        }
      });
    } else {
      // Retry once if grid header still rendering
      setTimeout(() => this.attachDeleteListener(), 300);
    }
  }

  onFirstDataRendered(params: any) {
    params.api.autoSizeAllColumns();
  }
  private buildAgGridDefs() {
    this.agColumnDefs = [];

    if (this.gridData?.showCheckBox && this.isHideForMobileView) {
      this.agColumnDefs.push({
        headerName: '',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 45,
        minWidth: 40,
        maxWidth: 50,
        filter: false,
        sortable: false,
        menuTabs: []
      });
    }

    const cols = this.gridData?.columnInfo || [];

    for (const col of cols) {
      // ✅ ACTION COLUMN
      if (col.label === 'Action') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: 'action',
          width: 120,
          sortable: false,
          filter: false,

          cellRenderer: (params: any) => {
            let html = '';

            if (this.TableName === 'Companies') {
              html = `
          <span class="material-icons cp" data-action="edit" 
            style="color:#ff9800;cursor:pointer;margin-right:8px;">
            edit
          </span>

          <span class="cp" data-action="profile" style="cursor:pointer; display:inline-flex; align-items:center;">
            <!-- SVG with no data-action required (we'll search ancestors on click) -->
            <svg width="22" height="22" viewBox="0 0 24 24"
                fill="none" stroke="#1976d2" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
              <path d="M4 16c0-6 6-10 14-10" />
              <path d="M4 20c0-6 6-10 14-10" />
              <path d="M18 6l4 4-4 4" />
            </svg>
          </span>
        `;
              return html;
            }

            if (this.TableName === 'Staff Management') {
              html = `
          <span class="material-icons cp" data-action="edit"
            style="color:#ff9800;cursor:pointer;">edit</span>
        `;
              return html;
            }

            if (this.TableName === 'Admin Access Matrix') {
              html = `
          <span class="material-icons cp" data-action="edit"
            style="color:#ff9800;cursor:pointer;margin-right:8px;">edit</span>
        `;
              return html;
            }

            return '';
          },

          onCellClicked: (params: any) => {
            // robustly find nearest ancestor with data-action (works if target is <path>, <svg>, or <span>)
            try {
              const rawTarget = params.event?.target as HTMLElement | null;
              if (!rawTarget) return;

              // use closest to search up the tree for element with data-action
              const actionEl = rawTarget.closest ? (rawTarget.closest('[data-action]') as HTMLElement | null) : null;
              const action = actionEl ? actionEl.getAttribute('data-action') : null;
              if (!action) return;

              if (action === 'edit') this.editDetail(params.data);
              else if (action === 'profile') this.showCompanyDetails(params.data);
              else if (action === 'delete') this.deleteDetail(params.data);
            } catch (err) {
              console.warn('Action click handler error', err);
            }
          }
        });
        continue;
      }

      if (col.propertyName === 'viewDetails') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,

          cellRenderer: () => `
            <span class="ag-view-details"
              style="color:#1976d2;cursor:pointer;font-weight:600;text-decoration: underline;">
              View Details
            </span>
          `,

          onCellClicked: (params: any) => {
            // Prevent row click
            params.event.stopPropagation();

            // Emit EXACT values popup needs
            this.detailsEmmiter.emit(
              this.rowToKeyValueArray(params.data) // <-- data (array)
            );
          }
        });
        continue;
      }

      if (col.label === 'Status') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: 'status',
          // resizable: true,
          width: 130,
          sortable: false,
          filter: false,
          cellRenderer: (params: any) => this.statusFormatter(params),
          autoHeight: true, // ✅ ensures row height adjusts to wrapped text
          cellStyle: { whiteSpace: 'normal' }
        });
        continue;
      }
      // 🔹 Make Import History numeric columns clickable
      const clickableImportColumns = ['Total', 'Add', 'Update', 'Skip'];

      if (clickableImportColumns.includes(col.propertyName)) {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,
          cellRenderer: (params: any) => {
            return `
        <span style="
          color:#1976d2;
          cursor:pointer;
          font-weight:600;
          text-decoration: underline;
        ">
          ${params.value ?? ''}
        </span>
      `;
          },
          onCellClicked: (params: any) => {
            this.detailsWithColumn.emit({
              data: this.rowToKeyValueArray(params.data),
              colName: col.propertyName
            });
          }
        });
        continue;
      }
      // MODULES COLUMN (array of objects)
      if (col.propertyName === 'modules') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,
          autoHeight: true,
          cellStyle: { whiteSpace: 'normal' },
          cellRenderer: (params: any) => {
            if (!params.value || !Array.isArray(params.value)) return '';

            const names = params.value.map((m: any) => m.moduleName).join(', ');

            return `
        <span style="white-space: normal; line-height: 1.4; font-weight: 500;">
          ${names}
        </span>
      `;
          }
        });
        continue;
      }
      if (col.propertyName === 'linkName') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,
          width: 170,
          cellRenderer: (params: any) => {
            return `
        <span class="ag-link-id"
              style="color:#1976d2;cursor:pointer;font-weight:600;">
          ${params.value ?? ''}
        </span>
      `;
          },

          onCellClicked: (params: any) => {
            const target = params.event.target;

            // 🔥 Only trigger when actual link (<span>) is clicked
            if (target && target.classList.contains('ag-link-id')) {
              if (this.TableName === 'Companies') {
                this.detailsEmmiter.emit(this.rowToKeyValueArray(params.data));
              } else if (this.TableName === 'Staff Management') {
                this.showDetails(params.data);
              }
            }
          }
        });

        continue;
      }

      // ✅ Company Name clickable (compName)
      if (col.propertyName === 'compName') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,
          checkboxSelection: false,
          width: 180,

          cellRenderer: (params: any) => {
            return `
              <span class="ag-link-id"
                    style="color:#1976d2;cursor:pointer;font-weight:600;">
                ${params.value ?? ''}
              </span>
            `;
          },

          onCellClicked: (params: any) => {
            const target = params.event.target;

            // 🔥 Only when clicking the span, not anywhere in cell
            if (target && target.classList.contains('ag-link-id')) {
              if (this.TableName === 'Companies') {
                this.showCompanyDetails(params.data);
              }
            }
          }
        });

        continue;
      }

      // ❌ No filter in this column
      if (col.propertyName === 'licenses') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,
          width: 110,
          sortable: false,
          filter: false
        });
        continue;
      }
      if (col.propertyName === 'employees') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,
          width: 70,
          sortable: false,
          filter: false
        });
        continue;
      }
      if (col.propertyName === 'sysLockDate') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,
          width: 160,
          sortable: false,
          filter: false
        });
        continue;
      }
      if (col.propertyName === 'startDate') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,
          width: 140,
          sortable: false,
          filter: false
        });
        continue;
      }
      if (col.propertyName === 'fiscalYear') {
        this.agColumnDefs.push({
          headerName: col.label,
          field: col.propertyName,
          width: 110,
          sortable: false,
          filter: false
        });
        continue;
      }

      // ✅ Default column
      this.agColumnDefs.push({
        headerName: col.label,
        field: col.propertyName
      });
    }

    const inputRows = Array.isArray(this.gridData?.columnData) ? this.gridData.columnData : [];
    const inputTotal = this.gridData?.totalCount ?? inputRows.length;

    // Only adopt the input as rowData if it already has ALL rows
    if (inputRows.length >= inputTotal && inputRows.length > 0) {
      this.agRowData = [...inputRows];
      if (this.gridApi) this.gridApi.setRowData(this.agRowData);
    }
    // else: do nothing here; loadAllCompanies() will populate agRowData
  }

  private rowToKeyValueArray(row: any): Array<{ key: string; value: any }> {
    return Object.entries(row ?? {}).map(([key, value]) => ({ key, value }));
  }
}
